import { Box, CircularProgress, Grid, Typography } from '@mui/material'
import { useCallback, useEffect, useState } from 'react'

interface Props {
    message?: string
}

export default function SplashPage({ message = 'Loading...' }: Props) {
    const [height, setHeight] = useState(0)
    const onResize = useCallback(() => {
        setHeight(window.innerHeight)
    }, [])
    useEffect(() => {
        setHeight(window.innerHeight)
        window.addEventListener('resize', onResize)

        return () => {
            window.removeEventListener('resize', onResize)
        }
    }, [height, onResize])

    return (
        <Grid
            container
            direction="column"
            justifyContent="center"
            alignItems="center"
            justifySelf="center"
            style={{
                height,
                display: height === 0 ? 'none' : undefined,
            }}
        >
            <CircularProgress size={60} />
            <Box mt={2}>
                <Typography variant="h5">{message}</Typography>
            </Box>
        </Grid>
    )
}
